<script>
    import Util from 'util/util';

    export let textString = '';

    // Match groups of consecutive tokens that Unicode categorises as letters and numbers.
    $: wordCount = (Util.stripTags(textString).match(/[\p{L}\p{N}]+/ug) || []).length;
</script>

<div class="counter">
    {window.i18n.sprintf(window.i18n.ngettext('%s word', '%s words', wordCount), wordCount)}
</div>

<style lang="scss">/*
* Scut, a collection of Sass utilities
* to ease and improve our implementations of common style-code patterns.
* v1.0.1
* Docs at http://davidtheclark.github.io/scut
*/
/* TODO implement tooltip arrow */
.counter {
  font-size: 14px;
  text-align: right;
  margin-top: 4px;
  color: rgba(18, 45, 64, 0.5);
}</style>
